var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SY"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_1692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.9941H15V9.99414H0V14.9941Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5H15V0H0V5Z",
    fill: "#E32139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 8.115L4.61832 8.71353L4.9151 7.69005L4.07342 7.03647L5.13851 7.00245L5.5 6L5.86149 7.00245L6.92658 7.03647L6.0849 7.69005L6.38168 8.71353L5.5 8.115Z",
    fill: "#128A49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 33_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 8.115L8.61832 8.71353L8.9151 7.69005L8.07342 7.03647L9.13851 7.00245L9.5 6L9.86149 7.00245L10.9266 7.03647L10.0849 7.69005L10.3817 8.71353L9.5 8.115Z",
    fill: "#128A49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy);
export default __webpack_public_path__ + "static/media/SY.3f5c790262f07d6fed34984c1f4d5168.svg";
export { ForwardRef as ReactComponent };